import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import announcements from '../announcements';

const STORAGE_KEY = 'dismissedAnnouncement';
const current = announcements.releases[0];

export default function AnnouncementBanner() {
    const { pathname } = useLocation();
    const [dismissed, setDismissed] = useState(
        () => localStorage.getItem(STORAGE_KEY) === announcements.current
    );
    const [modalOpen, setModalOpen] = useState(false);

    const handleModalClose = () => setModalOpen(false);

    const isLoggedIn = !!localStorage.getItem('user');
    const onLoginPage = pathname === '/login' || pathname === '/signup';
    const visible = announcements.enabled && isLoggedIn && !onLoginPage && !dismissed;

    if (!visible) return null;

    const handleDismiss = (e) => {
        e.stopPropagation();
        localStorage.setItem(STORAGE_KEY, announcements.current);
        setDismissed(true);
    };

    const handleGotIt = () => {
        localStorage.setItem(STORAGE_KEY, announcements.current);
        setDismissed(true);
        setModalOpen(false);
    };

    return (
        <>
            <Alert
                severity="info"
                icon={<NewReleasesIcon fontSize="small" />}
                sx={{ borderRadius: 0, py: 0.5, cursor: 'pointer' }}
                onClick={() => setModalOpen(true)}
                action={
                    <Tooltip title="Dismiss">
                        <IconButton size="small" onClick={handleDismiss}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                }
            >
                <strong>What's New:</strong> {current.summary}{' '}
                <Box component="span" sx={{ textDecoration: 'underline', ml: 0.5 }}>See details</Box>
            </Alert>

            <Dialog open={modalOpen} onClose={handleModalClose} fullWidth maxWidth="xs">
                {/* Header */}
                <Box sx={{ bgcolor: 'primary.main', px: 3, pt: 3, pb: 2.5, color: 'white' }}>
                    <Typography variant="overline" sx={{ opacity: 0.8, letterSpacing: 2 }}>
                        {current.date}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 800, mt: 0.25 }}>
                        {current.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.85 }}>
                        {current.summary}
                    </Typography>
                </Box>

                <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
                    {/* Current release features */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {current.features.map((f, i) => (
                            <Box key={i} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                <Box sx={{ fontSize: 28, lineHeight: 1, mt: 0.25, flexShrink: 0 }}>{f.icon}</Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{f.title}</Typography>
                                    <Typography variant="body2" color="text.secondary">{f.description}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button variant="outlined" fullWidth onClick={handleModalClose}>Close</Button>
                    <Button variant="contained" fullWidth onClick={handleGotIt}>Got it</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
